export default "__VITE_ASSET__WNUrZJhw__"